import classNames from 'classnames'
import React, { ReactNode } from 'react'

import { isHyphenatedLocale } from '../../locale/i18n'
import Heading from '../Heading'

import './Section.scss'

export type BackgroundColor = 'none' | 'light' | 'blue'

export interface SectionProps {
  id?: string
  className?: string
  backgroundColor?: BackgroundColor
  children?: React.ReactNode
  isRelative?: boolean
  mainTitle?: ReactNode
}

export const backgroundPropsToClassname = (
  backgroundColor: BackgroundColor,
) => {
  let color = ''

  for (let val of backgroundColor) {
    if (val === val.toUpperCase()) {
      val = '-' + val.toLowerCase()
    }
    color = color.concat(val)
  }

  return color
}

const Section = ({
  id,
  children,
  className,
  backgroundColor = 'none',
  isRelative,
  mainTitle,
}: SectionProps) => {
  const color = backgroundPropsToClassname(backgroundColor)

  return (
    <section
      className={classNames(
        'section',
        `section--${color}`,
        { 'section--relative': isRelative },
        className,
      )}
      id={id}
    >
      <div className="gutter gutter--center">
        {typeof mainTitle === 'string' ? (
          <Heading text={mainTitle} />
        ) : (
          mainTitle
        )}
        <div
          className={classNames('section__content', {
            hyphenate: isHyphenatedLocale(),
          })}
        >
          {children}
        </div>
      </div>
    </section>
  )
}

export default Section
